'use client';
import * as React from 'react';

var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgCertificate = function SvgCertificate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.25 17.5V22L12 20.875 9.75 22v-4.5",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m8.22 14.837.532.7.115.865v0c.064.48.441.857.92.921l.868.116.694.531v0c.384.292.916.292 1.3 0l.7-.531.866-.116v0c.48-.064.858-.441.922-.921l.116-.867.53-.694v0a1.074 1.074 0 0 0 0-1.3l-.53-.7-.116-.865v0a1.07 1.07 0 0 0-.92-.922l-.868-.115-.7-.53v0a1.07 1.07 0 0 0-1.3 0l-.7.53-.866.115v0c-.48.064-.857.441-.921.921l-.116.867-.531.694v0c-.29.386-.288.918.005 1.301",
    vectorEffect: "non-scaling-stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17 19h2v0a2 2 0 0 0 2-2V5.593a2 2 0 0 0-2-2H5v0a2 2 0 0 0-2 2V17a2 2 0 0 0 2 2h2M7.5 7h9",
    vectorEffect: "non-scaling-stroke"
  })));
};

export { SvgCertificate as default };
//# sourceMappingURL=certificate.svg.js.map
